import axios from "axios";
import cfg from "@/service/Configurations";

await cfg.initialize();

const reportServerApi = axios.create({
    baseURL: cfg.getConfiguration('VUE_APP_REPORT_SERVER_URL')
});

export default reportServerApi;